import {
	Backdrop,
	CircularProgress,
	Container,
	Grid,
	Paper,
	Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import { useAPI } from "../../../apiContext";

const MyProfile = () => {
	const { data } = useAPI();
	const [seeMore, setSeeMore] = useState(false);
	return (
		<Container>
			{data?._id ? (
				<Box
					display='flex'
					justifyContent='center'
					alignItems='center'
					minHeight='80vh'>
					<Paper elevation={3} sx={{ p: 2, borderRadius: "17px", my: 2 }}>
						<Grid
							container
							spacing={2}
							display='flex'
							justifyContent='center'
							alignItems='center'>
							<Grid item md={5} xs={12} sx={{ mx: "auto" }}>
								<img
									src={data?.profile?.imageLink2 || "/user.jpg"}
									style={{
										width: "100%",
										height: "100%",
										borderRadius: "15px",
									}}
									alt=''
								/>
							</Grid>
							<Grid item md={7} xs={12} sx={{ mx: "auto", textAlign: "left" }}>
								<Typography
									className='textColor'
									sx={{ fontWeight: "bold", fontSize: "1.8rem" }}>
									{data?.headline?.title || "N/A"}
								</Typography>
								<Typography
									className='textColor'
									sx={{ fontWeight: "bold", fontSize: "1.4rem" }}>
									{data?.headline?.subtitle || "N/A"}
								</Typography>
								<Typography
									className='textColor'
									sx={{ fontWeight: "bold", fontSize: "1rem" }}>
									Joined :- {data?.joiningTime || "N/A"}
								</Typography>
								<Box sx={{ display: "flex", alignItems: "center", my: 0.5 }}>
									<LocalPhoneIcon className='textColor' sx={{ mr: 1 }} />
									<Typography className='textColor' sx={{ fontWeight: "bold" }}>
										{data?.links?.call || "N/A"}
									</Typography>
								</Box>
								<Box sx={{ display: "flex", alignItems: "center", my: 0.5 }}>
									<EmailIcon className='textColor' sx={{ mr: 1 }} />
									<Typography className='textColor' sx={{ fontWeight: "bold" }}>
										{data?.links?.email || "N/A"}
									</Typography>
								</Box>
								<a
									className='textColor'
									href={`${window.location.origin.toString()}`}>
									<Box sx={{ display: "flex", alignItems: "center", my: 0.5 }}>
										<PermIdentityIcon className='textColor' sx={{ mr: 1 }} />
										<Typography
											className='textColor'
											sx={{ fontWeight: "bold" }}>
											{`${window.location.origin.toString()}`}
										</Typography>
									</Box>
								</a>
								<Typography className='textColor' sx={{ fontSize: "1rem" }}>
									<span style={{ fontWeight: "bold" }}>
										{data?.headline?.aboutUs} :-{" "}
									</span>

									{seeMore ? (
										<>
											{data?.details?.details}{" "}
											<span
												onClick={() => setSeeMore(false)}
												style={{
													fontWeight: "bold",
													textDecoration: "underline",
													cursor: "pointer",
												}}>
												See Less
											</span>
										</>
									) : (
										<>
											{data?.details?.details.slice(0, 300)}....
											<span
												onClick={() => setSeeMore(true)}
												style={{
													fontWeight: "bold",
													textDecoration: "underline",
													cursor: "pointer",
												}}>
												See More
											</span>
										</>
									)}
								</Typography>
							</Grid>
						</Grid>
					</Paper>
				</Box>
			) : (
				<Backdrop
					sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={true}>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</Container>
	);
};

export default MyProfile;
